/**
 * SignupPage Component
 *
 * Gateway for new user signup. Shows "Join Royale" → phone confirmation overlay.
 * On phone confirmation success, reloads with pending_otp_required flag so
 * DemoGate shows the OTP screen for verification.
 *
 * Also used in invite mode (from the chat invite CTA) with X button to go back.
 */

import { useState } from 'react';
import { useNavigation } from '../contexts/NavigationContext';
import { ButtonRounded } from '../components/UISystem/Buttons';
import { X } from '@phosphor-icons/react/dist/ssr/X';
import IconBack from '../components/UISystem/Icons/IconBack';
import PendingProfileOverlay from '../components/Overlay/PendingProfileOverlay';
import { CROWN_BLACK } from '../styles/brandAssets';

const SignupPage = () => {
  const { goBack, navigateTo, screenParams } = useNavigation();
  const [showPhoneOverlay, setShowPhoneOverlay] = useState(false);

  const isInviteMode = screenParams?.mode === 'invite';
  const profileName = screenParams?.profileName;

  const handleJoin = () => {
    setShowPhoneOverlay(true);
  };

  const handlePhoneSuccess = () => {
    setShowPhoneOverlay(false);
    // Flag tells DemoGate to show OTP screen on next load
    sessionStorage.setItem('pending_otp_required', 'true');
    sessionStorage.setItem('signup_initiated', 'true');
    window.location.href = '/';
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        backgroundColor: '#FFFFFF',
        position: 'relative',
      }}
    >
      {/* X button — invite mode only */}
      {isInviteMode && (
        <div
          style={{
            position: 'fixed',
            top: 'calc(16px + env(safe-area-inset-top))',
            left: '16px',
            zIndex: 10,
          }}
        >
          <IconBack icon={X} onClick={() => goBack()} />
        </div>
      )}

      {/* Crown icon */}
      <img
        src={CROWN_BLACK}
        alt=""
        style={{
          width: '64px',
          height: '40px',
        }}
      />

      {/* Heading */}
      <h1
        style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#000000',
          marginTop: '20px',
          marginBottom: profileName ? '4px' : '0',
        }}
      >
        Welcome
      </h1>

      {/* Profile name — invite mode only */}
      {isInviteMode && profileName && (
        <div
          style={{
            fontSize: '17px',
            color: '#8E8E93',
            marginBottom: '0',
          }}
        >
          You&apos;re invited by {profileName}
        </div>
      )}

      {/* Join button */}
      <ButtonRounded
        text="Join Royale"
        size="auto"
        onClick={handleJoin}
        style={{ marginTop: '32px' }}
      />

      {/* Tagline */}
      <p
        style={{
          fontSize: '15px',
          color: '#8E8E93',
          marginTop: '16px',
        }}
      >
        Magic address book
      </p>

      {/* Log in link — for existing users returning after cleared storage */}
      {!isInviteMode && (
        <>
          <ButtonRounded
            text="Log in"
            variant="blank"
            size="inline"
            onClick={() => {
              sessionStorage.setItem('pending_otp_required', 'true');
              window.location.href = '/';
            }}
            style={{ marginTop: '24px' }}
          />
          <ButtonRounded
            text="UI Showcase"
            variant="blank"
            size="inline"
            onClick={() => navigateTo('ui-showcase')}
            style={{ marginTop: '12px', fontSize: '13px', color: '#C7C7CC' }}
          />
        </>
      )}

      {/* Phone confirmation overlay */}
      <PendingProfileOverlay
        show={showPhoneOverlay}
        onClose={() => setShowPhoneOverlay(false)}
        onSuccess={handlePhoneSuccess}
      />
    </div>
  );
};

export default SignupPage;
